module.exports = __webpack_public_path__ + "img/informacoes-fp.0d6019cb.svg";